$(document).ready(function() {
    // Get the product tags from the data attribute
var productTags = $('.container').data('tags');
var tagsArray = [];

if (productTags) {
    if (Array.isArray(productTags)) {
        tagsArray = productTags;
    } else if (typeof productTags === 'string') {
        tagsArray = productTags.split(',');
    }

// Get the current month as default
var currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
$('#eta-month').text(currentMonth); // Set default month

// Check for an autoboat-eta-[Month] tag
var etaTagautoboat = tagsArray.find(tag => tag.startsWith('autoboat-eta-'));
if (etaTagautoboat) {
    var month = etaTag.replace('autoboat-eta-', ''); // Extract the month
    $('#eta-month').text(month); // Update the month in the span
}


        // Show or hide elements based on tags
        if (tagsArray.includes('pbl-epro')) {
            $('.pbl-epro, .pbl-eproinv').show();
        } else if (tagsArray.includes('pbl-hydro')) {
            $('.pbl-hydro, .pbl-hydroinv').show();
          
        } else if (tagsArray.includes('pbl-autoboat')) {
            $('.pbl-autoboat').show();
        } else if (tagsArray.includes('pbl-mto')) {
            $('.pbl-mto').show();  
        } else if (tagsArray.includes('pbl-basemanualbackorder')) {
            $('.pbl-base, .pbl-baseinv, .pbl-backorder').show();
        } else {
            // Show .pbl-base if no specific tags are present
            $('.pbl-base, .pbl-baseinv').show();
        }

        // Show the rebate bullet second in the list for tagged products.
        // Copy comes from the product metafield custom.rebate_message when set.
        if (tagsArray.map(tag => tag.trim()).includes('250rebate')) {
            var rebateCopy = (typeof window.rebateMessage === 'string' && window.rebateMessage.trim())
                ? window.rebateMessage.trim()
                : '$250 rebate will be issued to the original payment method used for the purchase.';
            $('ul.pbl').each(function () {
                var $list = $(this);
                if ($list.find('.pbl-rebate').length) return;
                var $rebate = $('<li class="pbl-rebate"></li>').html(rebateCopy);
                var $firstVisible = $list.children('li:visible').first();
                if ($firstVisible.length) {
                    $firstVisible.after($rebate);
                } else {
                    $list.prepend($rebate);
                }
            });
        }

// Check for a pbl-mto-[custom text] tag
var mtoTag = tagsArray.find(tag => tag.startsWith('pbl-mto-'));

if (mtoTag) {
    var mtoText = mtoTag.replace('pbl-mto-', ''); // Extract the custom text
    $('.pbl-green').text(`Made to Order - ${mtoText}`); // Update the span text
}



       var etaTag = tagsArray.find(tag => tag.startsWith('eta-'));

       if (etaTag) {
    var etaDate = etaTag.replace('eta-', ''); // Extract the date
    $('.pbl-backorder').html(`<span class="pbl-red">On Backorder - ETA ${etaDate}</span>`).show();
    $('.pbl-instock').hide();
}

        // Check for specific timeframe tags
        if (tagsArray.includes('pbl-3-5days')) {
            $('.pbl-3-5days').show();
            $('.pbl-2-weeks, .pbl-1-month').hide();
        } else if (tagsArray.includes('pbl-2-weeks')) {
            $('.pbl-2-weeks').show();
            $('.pbl-3-5days, .pbl-1-month').hide();
        } else if (tagsArray.includes('pbl-1-month')) {
            $('.pbl-1-month').show();
            $('.pbl-3-5days, .pbl-2-weeks').hide();
        } else if (etaTag) {
            // If an ETA tag exists but no timeframe tags exist, show the backorder message but hide timeframe elements
            $('.pbl-3-5days, .pbl-2-weeks, .pbl-1-month').hide();
        } else {
            // Hide all if no relevant tags are present
            $('.pbl-3-5days, .pbl-2-weeks, .pbl-1-month').hide();
            $('.pbl-backorder').hide();
            $('.pbl-instock').show();
        }


    }

  
});


$(document).ready(function () {

    const intervalTime = 200; // 1 second

    function logSelectedVariantInventory() {
        const selectedVariantId = $("select[name='id']").val() || $("input[name='id']:checked").val();

        if (selectedVariantId) {
            const variantInventory = window.variantInventories?.[selectedVariantId];

            // Get the inventory tracking method
            var trackQuantity = $(`option[value="${selectedVariantId}"]`).data('track-quantity') || $('.container').data('track-quantity');


            if (variantInventory !== undefined) {
                // Get the updated inventory policy directly after variant change
                var inventoryPolicy = $(`option[value="${selectedVariantId}"]`).data('inventory-policy') || $('.container').data('inventory-policy');
                console.log(`Variant ID: ${selectedVariantId}, Inventory: ${variantInventory}, Inventory Policy: ${inventoryPolicy}, Track Quantity: ${trackQuantity}`);
            } else {
                console.warn(`Variant ID: ${selectedVariantId}, Inventory data not found, Track Quantity: ${trackQuantity}`);
            }

            // Get the inventory level, continue selling status, and inventory management status from the data attributes
            var inventoryManagement = $('.container').data('inventory-management'); // Should be 'null' for untracked inventory
// REPLACE your old 'var productTags...' lines with this block:

var productTags = $('.container').data('tags');
var tagsArray = [];

// 1. Check if it's ALREADY an array (like in your screenshot)
if (Array.isArray(productTags)) {
    tagsArray = productTags;
} 
// 2. If it's just text, split it manually (like your other products)
else if (typeof productTags === 'string') {
    tagsArray = productTags.split(',');
}

var isEtaTag = tagsArray.find(tag => tag.startsWith('is-eta-'));
if (isEtaTag) {
    var etaText = isEtaTag.replace('is-eta-', '');
    $('.pbl-instock').html(`<span class="pbl-green">In Stock - Ships in ${etaText}</span>`);
}


          
            // Handle inventory visibility logic
           if (trackQuantity === 'shopify') {
    if (variantInventory > 0) {
        // Product is in stock and inventory is tracked
        $('.pbl-instock').show();
        $('.pbl-backorder, .pbl-oos').hide();
    } else if (variantInventory <= 0) {
        if (inventoryPolicy === 'continue') {
            // Product is out of stock, but backorders are allowed
            $('.pbl-backorder').show();
            $('.pbl-instock, .pbl-oos').hide();
        } else {
            // Product is out of stock, and backorders are not allowed
            $('.pbl-oos').show();
            $('.pbl-instock, .pbl-backorder').hide();
        }
    } 

    // Separate condition for .items_left
    if (variantInventory > 0 && variantInventory < 11) {
        $('.items_left').show();
    } else {
        $('.items_left').hide();
    }
}

    if (productTags) {
    var tagsArray = [];
    if (Array.isArray(productTags)) {
        tagsArray = productTags;
    } else if (typeof productTags === 'string') {
        tagsArray = productTags.split(',');
    }

        // Check if there is an eta-[date] tag
        var etaTag = tagsArray.find(tag => tag.startsWith('eta-'));

        if (trackQuantity !== 'shopify') {
            if (etaTag) {
    var etaDate = etaTag.replace('eta-', ''); // Extract the date
    $('.pbl-backorder').html(`<span class="pbl-red">On Backorder - ETA ${etaDate}</span>`).show();
    $('.pbl-instock').hide();
} else {
                // Show .pbl-base if no specific tags are present
                $('.pbl-instock').show();
                $('.pbl-backorder, .pbl-oos').hide();
            }
        }
    }

if (
  window.customStockMessagesRed ||
  window.customStockMessagesGreen ||
  window.customStockMessagesYellow // 👈 add yellow
) {
  setTimeout(() => {
    try {
      const redMessage = window.customStockMessagesRed?.[selectedVariantId];
      const greenMessage = window.customStockMessagesGreen?.[selectedVariantId];
      const yellowMessage = window.customStockMessagesYellow?.[selectedVariantId]; // 👈 yellow

const productTags = $('.container').data('tags');
let tagsArray = [];

if (Array.isArray(productTags)) {
    tagsArray = productTags;
} else if (typeof productTags === 'string') {
    tagsArray = productTags.split(',');
}

      const matchingTag = tagsArray.find(tag =>
        tag.startsWith('pbl-') && !tag.includes('-inv') && !tag.includes('-mto-')
      );
      if (!matchingTag) {
        console.warn('[StockMsg] No matching tag found for container.');
        return;
      }

      const invScope = $(`.${matchingTag}inv`);
      if (!invScope.length) {
        console.warn(`[StockMsg] No .${matchingTag}inv container found.`);
        return;
      }

      const inStockEl = invScope.find('.pbl-instock');
      const backOrderEl = invScope.find('.pbl-backorder');
      const oosEl = invScope.find('.pbl-oos');

      // Save original content once
      if (inStockEl.length && !inStockEl.data('original-text')) {
        inStockEl.data('original-text', inStockEl.html().trim());
      }
      if (backOrderEl.length && !backOrderEl.data('original-text')) {
        backOrderEl.data('original-text', backOrderEl.html().trim());
      }
      if (oosEl.length && !oosEl.data('original-text')) {
        oosEl.data('original-text', oosEl.html().trim());
      }

      // PRIORITY: red > green > yellow
      let message, color, type;
      if (redMessage?.trim()) {
        message = redMessage.trim();
        color = '#f00404';
        type = 'red';
      } else if (greenMessage?.trim()) {
        message = greenMessage.trim();
        color = '#047104';
        type = 'green';
      } else if (yellowMessage?.trim()) {
        message = yellowMessage.trim();
        color = '#f5a623';
        type = 'yellow';
      }

      if (message) {
        const styledMessage = `<span style="color:${color}; font-weight:700;">${message}</span>`;

        if (inStockEl.is(':visible')) {
          console.log(`[StockMsg] Injecting into .pbl-instock (${type}):`, message);
          inStockEl.html(styledMessage);
        } else if (backOrderEl.is(':visible')) {
          console.log(`[StockMsg] Injecting into .pbl-backorder (${type}):`, message);
          backOrderEl.html(styledMessage);
        } else if (oosEl.is(':visible')) {
          console.log(`[StockMsg] Injecting into .pbl-oos (${type}):`, message);
          oosEl.html(styledMessage);
        }

        console.log(`✅ Applied ${type} stock message: ${message}`);
      } else {
        // Restore original content if no message
        if (inStockEl.length && inStockEl.data('original-text')) {
          console.log('[StockMsg] Restoring original .pbl-instock content');
          inStockEl.html(inStockEl.data('original-text'));
        }
        if (backOrderEl.length && backOrderEl.data('original-text')) {
          console.log('[StockMsg] Restoring original .pbl-backorder content');
          backOrderEl.html(backOrderEl.data('original-text'));
        }
        if (oosEl.length && oosEl.data('original-text')) {
          console.log('[StockMsg] Restoring original .pbl-oos content');
          oosEl.html(oosEl.data('original-text'));
        }

        console.log('🔁 No stock message metafield — restored default text');
      }
    } catch (err) {
      console.error('❌ Error applying stock message:', err);
    }
  }, 10);
}














        }
    }

    // Set interval to check and log the selected variant inventory
    setInterval(logSelectedVariantInventory, intervalTime);

    // Update the inventory data whenever a variant is changed
    $(document).on('change', 'select[name="id"], input[name="id"]:checked', function() {
        logSelectedVariantInventory(); // Call the function on variant change
    });
});



